
// STYLES
import styles from '../css/menu.module.css';



export default function RenderCategories ({item, index, companyData, category, selectCategory }) {

    const textStyle = { 
        color: category == item.title ? companyData.background_color : '#b3b3b3', 
        fontWeight: 600, 
        whiteSpace: 'nowrap', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis', 
        maxWidth: 150
    }

    if(item.products.length > 0){
        return (
            <li key={index}>
                <button id={`cat${index}`} className={styles.btnCategory} onClick={() => selectCategory(item.title)}>
                    <p style={textStyle}>{item.title}</p>
                </button>
            </li>
            
        );
    }
};